import React from 'react';
import styles from './FeatureCalloutsSection.module.css';

export default function FeatureCalloutsSection() {
  return (
    <>
      {/* SECTION 1 — For Students */}
      <section className={styles.scene}>
        <div className={styles.glow1} aria-hidden="true" />
        <div className={styles.glow2} aria-hidden="true" />

        <div className={styles.sceneInner}>
          <div className={styles.artworkSide}>
            <img
              src="/scout_images/scoutforstudents.png"
              alt="Scout helping students stay organized"
              className={styles.hero}
            />
          </div>
          <div className={styles.textSide}>
            <span className={styles.eyebrow}>For Students</span>
            <h2 className={styles.headline}>Built for students.</h2>
            <h3 className={styles.subheadline}>Stay ahead without thinking about it.</h3>
            <p className={styles.body}>
              Upload your syllabus once and DocuHounds organizes your entire semester — classes, deadlines, assignments, notes, and study tools in one place.
            </p>
            <ul className={styles.checks}>
              <li className={styles.checkItem}><span className={styles.checkMark}>✓</span> Automatic planning</li>
              <li className={styles.checkItem}><span className={styles.checkMark}>✓</span> AI study tools</li>
              <li className={styles.checkItem}><span className={styles.checkMark}>✓</span> Deadline tracking</li>
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 2 — For Parents (reversed) */}
      <section className={styles.scene}>
        <div className={styles.glow3} aria-hidden="true" />
        <div className={styles.glow4} aria-hidden="true" />

        <div className={`${styles.sceneInner} ${styles.reversed}`}>
          <div className={styles.textSide}>
            <span className={styles.eyebrow}>For Parents</span>
            <h2 className={styles.headline}>Trusted by parents.</h2>
            <h3 className={styles.subheadline}>Support without micromanaging.</h3>
            <p className={styles.body}>
              See completion, upcoming deadlines, missing work, calendars, and academic risk scores — before small problems become big ones.
            </p>
            <ul className={styles.checks}>
              <li className={styles.checkItem}><span className={styles.checkMark}>✓</span> Early alerts</li>
              <li className={styles.checkItem}><span className={styles.checkMark}>✓</span> Progress visibility</li>
              <li className={styles.checkItem}><span className={styles.checkMark}>✓</span> Risk insights</li>
            </ul>
          </div>
          <div className={styles.artworkSide}>
            <img
              src="/scout_images/scoutforparents.png"
              alt="Scout giving parents academic visibility"
              className={styles.hero}
            />
          </div>
        </div>
      </section>
    </>
  );
}
